<ion-header>
  <app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content padding style="background-color: #04c4fc">
	<div class="wrapper">
	<div class="profile-avatar">
    <img *ngIf="!profile && !profile.profile_avatar_path" src="{{this.getDefaultAvatar(profile)}}" class="sophie">
    <img *ngIf="profile && profile.profile_avatar_path" src="{{profile.profile_avatar_path}}" class="sophie">
	<div class="profile-name" *ngIf="!profile && !profile.profile_nickName">{{profile.profile_firstName}}</div>
	<div class="profile-name" *ngIf="profile && profile.profile_nickName">{{profile.profile_nickName}}</div>
	</div>
  <ion-list>
		<form #loginProfileForm ="ngForm">
		  <ion-item class="blue-item">
		    <ion-label stacked [innerHTML] = "'ACCOUNT.PARENT_LOGIN.PASSWORD_LABEL' | translate"></ion-label>
		    <ion-input [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" type="password" name="password" required [(ngModel)]="model.password" #password = "ngModel"></ion-input>
		  </ion-item>
		  <div class="qmarkwrapper"> <img (click)="presentPopover($event)" class="qmark" src="../../../assets/img/qmark.png" /></div>
		  <div class="errortext" [hidden] = "!error || password.dirty">{{'ERROR.PARENT_LOGIN.INVALID' | translate}}</div>
		  <div class="errortext" [hidden]= "password.valid || password.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
		  <ion-item class="forgot blue-item" *ngIf = "!noResetPswd" (click) = "goToForgotPassword()">{{'ACCOUNT.PARENT_LOGIN.FORGOT_PARENT_PASSWORD' | translate}}</ion-item>
		  <ion-button class="connect" [disabled] = "!loginProfileForm.valid" (click)="loginProfile(); loginProfileForm.reset()">{{'ACCOUNT.PARENT_LOGIN.BUTTON' | translate}}</ion-button>
		</form>
  </ion-list>
	</div>
</ion-content>
<ion-footer>
	<app-bottom-menu></app-bottom-menu>
</ion-footer>
